(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,5945],{

/***/ 53174:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(90728);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CE": function() { return /* binding */ fetchSection; },
/* harmony export */   "Gr": function() { return /* binding */ fetchSections; },
/* harmony export */   "Jt": function() { return /* binding */ fetchCurationByType; }
/* harmony export */ });
/* unused harmony export fetchCuration */
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39322);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45874);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};


var fetchSections = function() {
    var _ref = _asyncToGenerator(function(type) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/sections/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            type: type
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchSections(type) {
        return _ref.apply(this, arguments);
    };
}();
var fetchSection = function() {
    var _ref = _asyncToGenerator(function(sectionId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/sections/".concat(sectionId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchSection(sectionId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchCuration = function() {
    var _ref = _asyncToGenerator(function(sectionId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/sections/".concat(sectionId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchCuration(sectionId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchCurationByType = function() {
    var _ref = _asyncToGenerator(function(type) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/curations/".concat(type, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchCurationByType(type) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 23516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ PushSize; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96964);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  box-sizing: content-box;\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var pushCSS = function(isTopSafeArea, isBottomSafeArea) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject(), isTopSafeArea && (0,_styles_css__WEBPACK_IMPORTED_MODULE_2__/* .safeArea */ .BI)("top"), isBottomSafeArea && (0,_styles_css__WEBPACK_IMPORTED_MODULE_2__/* .safeArea */ .BI)("bottom", "padding", chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium));
};
var Push = function(param, ref) {
    var _top = param.top, top = _top === void 0 ? false : _top, _bottom = param.bottom, bottom = _bottom === void 0 ? false : _bottom, size = param.size;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        ref: ref,
        css: pushCSS(top, bottom),
        style: {
            height: size
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Push));
var PushSize;
(function(PushSize) {
    PushSize[PushSize["safe"] = 0] = "safe";
    PushSize[PushSize["header"] = 44] = "header";
    PushSize[PushSize["bottomButton"] = 64] = "bottomButton";
    PushSize[PushSize["bottomTab"] = 56] = "bottomTab";
    PushSize[PushSize["commentForm"] = 70] = "commentForm";
    PushSize[PushSize["tab"] = 43] = "tab";
    PushSize[PushSize["floatingButton"] = 72] = "floatingButton";
})(PushSize || (PushSize = {}));


/***/ }),

/***/ 65583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54909);
/* harmony import */ var _api_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98379);
/* harmony import */ var _components_common_Banner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6913);




var CurationBanner = function(param) {
    var sectionId = param.sectionId;
    var data = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)([
        "sectionBanner",
        sectionId
    ], function() {
        return (0,_api_common__WEBPACK_IMPORTED_MODULE_1__/* .fetchSectionBanners */ .dE)(sectionId);
    }).data;
    if (!data) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_common_Banner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        name: "section-banner",
        size: _components_common_Banner__WEBPACK_IMPORTED_MODULE_2__/* .BannerSize.curation */ .Kj.curation,
        items: data
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CurationBanner);


/***/ }),

/***/ 4831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useWebtoonStoriesQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54909);
/* harmony import */ var _api_webtoon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83869);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60186);
/* harmony import */ var _utils_webtoon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23043);





var useWebtoonStoriesQuery = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isMounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setMounted(true);
    }, []);
    var storyToonsQuery = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .QUERY_KEYS.WEBTOON.STORIES */ .U7.WEBTOON.STORIES, function() {
        return (0,_api_webtoon__WEBPACK_IMPORTED_MODULE_2__/* .fetchStoryToons */ .Rh)();
    }, {
        enabled: isMounted,
        suspense: false,
        retry: false,
        useErrorBoundary: false,
        staleTime: 1000 * 60 * 5
    });
    var webtoonListItems = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var _data;
        var storyToons = (_data = storyToonsQuery.data) !== null && _data !== void 0 ? _data : [];
        return storyToons.reduce(function(items, storyToon) {
            var ref;
            var webtoonId = (0,_utils_webtoon__WEBPACK_IMPORTED_MODULE_4__/* .getStoryToonId */ .E6)(storyToon);
            if (typeof webtoonId !== "number") {
                return items;
            }
            var _storyId;
            var storyId = (_storyId = storyToon.storyId) !== null && _storyId !== void 0 ? _storyId : (ref = storyToon.story) === null || ref === void 0 ? void 0 : ref.id;
            items.push({
                webtoonId: webtoonId,
                storyId: storyId,
                storyToon: storyToon,
                meta: _constants__WEBPACK_IMPORTED_MODULE_3__/* .WEBTOON_STORIES.find */ .lV.find(function(story) {
                    return story.id === webtoonId;
                })
            });
            return items;
        }, []);
    }, [
        storyToonsQuery.data
    ]);
    var webtoonStories = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return webtoonListItems.map(function(param) {
            var webtoonId = param.webtoonId, storyId = param.storyId, storyToon = param.storyToon, meta = param.meta;
            var story = storyToon.story;
            return {
                webtoonId: webtoonId,
                storyId: storyId,
                title: (0,_utils_webtoon__WEBPACK_IMPORTED_MODULE_4__/* .getStoryToonTitle */ .KW)(storyToon, meta) || (story === null || story === void 0 ? void 0 : story.title) || "",
                subtitle: (0,_utils_webtoon__WEBPACK_IMPORTED_MODULE_4__/* .getStoryToonSubtitle */ .v$)(storyToon, meta) || (story === null || story === void 0 ? void 0 : story.summary) || "",
                authorName: (0,_utils_webtoon__WEBPACK_IMPORTED_MODULE_4__/* .getStoryToonAuthorName */ .KK)(storyToon),
                coverImage: (0,_utils_webtoon__WEBPACK_IMPORTED_MODULE_4__/* .getStoryToonCoverImage */ .tm)(storyToon),
                storyToon: storyToon,
                story: story,
                meta: meta
            };
        });
    }, [
        webtoonListItems
    ]);
    return {
        isMounted: isMounted,
        isLoading: !isMounted || storyToonsQuery.isLoading,
        isError: storyToonsQuery.isError,
        webtoonStories: webtoonStories,
        storyToonsQuery: storyToonsQuery
    };
};


/***/ }),

/***/ 41785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ BROADCAST_CHANNEL; },
/* harmony export */   "t": function() { return /* binding */ useBroadcastChannel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var broadcast_channel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38718);
/* harmony import */ var semver__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64912);
/* harmony import */ var semver__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(semver__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60186);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30259);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45874);






var BROADCAST_CHANNEL = {
    CHARACTER_UPDATE: "character_update",
    CHARACTER_DELETE: "character_delete",
    VERIFICATION_EVENT_CONFIRM: "verification_event_confirm",
    PURCHASE_DAILY_FREE_PASS: "purchase_daily_free_pass"
};
function useBroadcastChannel(channelName, onMessage, options) {
    var ref = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_3__/* .useGlobalContext */ .bN)(), platform = ref.platform, os = ref.os;
    var isUnderVersion = platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && os && !semver__WEBPACK_IMPORTED_MODULE_1___default().gte((0,_utils_misc__WEBPACK_IMPORTED_MODULE_4__/* .normalizeVersion */ .Kt)(os), "15.4.0");
    var broadcastChannelRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var onMessageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var handlePostMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(message) {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && isUnderVersion) {
            return;
        }
        if (broadcastChannelRef.current) {
            broadcastChannelRef.current.postMessage(message);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && isUnderVersion) {
            return;
        }
        if (onMessage) {
            onMessageRef.current = onMessage;
        }
    }, [
        onMessage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && isUnderVersion) {
            return;
        }
        var mounted = true;
        var channel = new broadcast_channel__WEBPACK_IMPORTED_MODULE_5__/* .BroadcastChannel */ .g0(channelName, options);
        var handleMessage = function(message) {
            var ref;
            if (!mounted) {
                return;
            }
            (ref = onMessageRef.current) === null || ref === void 0 ? void 0 : ref.call(onMessageRef, message);
        };
        channel.onmessage = handleMessage;
        broadcastChannelRef.current = channel;
        return function() {
            mounted = false;
            broadcastChannelRef.current = null;
            channel.close();
        };
    }, [
        channelName,
        options
    ]);
    return {
        postChannelMessage: handlePostMessage
    };
}


/***/ }),

/***/ 90728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HomeLoading": function() { return /* binding */ HomeLoading; },
  "ListLoading": function() { return /* binding */ ListLoading; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/react-query-virtual-8f3bd3534b/0/cache/react-query-npm-3.39.3-72b2a93edf-d2de6a0992.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(54909);
// EXTERNAL MODULE: ./hooks/useBroadcastChannel.ts
var useBroadcastChannel = __webpack_require__(41785);
// EXTERNAL MODULE: ./hooks/useModal.ts
var useModal = __webpack_require__(48294);
// EXTERNAL MODULE: ./hooks/useMounted.ts
var useMounted = __webpack_require__(38464);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var esm = __webpack_require__(9150);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(82740);
// EXTERNAL MODULE: ./.yarn/cache/date-fns-npm-2.30.0-895c790e0f-f7be015232.zip/node_modules/date-fns/esm/minutesToMilliseconds/index.js
var minutesToMilliseconds = __webpack_require__(72218);
// EXTERNAL MODULE: ./components/common/HomeHeader.tsx + 8 modules
var HomeHeader = __webpack_require__(7436);
// EXTERNAL MODULE: ./components/common/Tab.tsx
var Tab = __webpack_require__(93127);
// EXTERNAL MODULE: ./components/common/Banner.tsx
var Banner = __webpack_require__(6913);
// EXTERNAL MODULE: ./components/outlook/Divider.tsx
var Divider = __webpack_require__(91708);
// EXTERNAL MODULE: ./api/common.ts
var common = __webpack_require__(98379);
// EXTERNAL MODULE: ./constants/index.ts + 1 modules
var constants = __webpack_require__(60186);
// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
;// CONCATENATED MODULE: ./components/home/HomeBanner.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 112px;\n\n  ",
        " {\n    padding: 12px 0;\n    background-color: ",
        ";\n  }\n  ",
        " {\n    padding: 16px 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var layoutCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject(), css/* media.tablet */.BC.tablet, theme.var.gray50, css/* media.desktop */.BC.desktop);
};
var HomeBanner = function() {
    var ref = (0,react.useState)(false), isAutoPlayEnabled = ref[0], setIsAutoPlayEnabled = ref[1];
    var ref1 = (0,es.useQuery)(constants/* QUERY_KEYS.BANNER */.U7.BANNER(constants/* SectionType.standardRecommend */.bA.standardRecommend), function() {
        return (0,common/* fetchCurrationBanners */.Ou)(constants/* SectionType.standardRecommend */.bA.standardRecommend);
    }, {
        staleTime: 1000 * 60 * 15,
        cacheTime: 1000 * 60 * 15,
        suspense: false
    }), bannerList = ref1.data;
    (0,react.useEffect)(function() {
        setIsAutoPlayEnabled(true);
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: !!(bannerList === null || bannerList === void 0 ? void 0 : bannerList.length) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            css: layoutCSS,
            suppressHydrationWarning: true,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Banner/* default */.ZP, {
                    name: "home-banner",
                    size: Banner/* BannerSize.home */.Kj.home,
                    items: bannerList,
                    isBorder: false,
                    priority: true,
                    autoPlay: !!isAutoPlayEnabled
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Divider/* default */.Z, {})
            ]
        })
    });
};
/* harmony default export */ var home_HomeBanner = (HomeBanner);

// EXTERNAL MODULE: ./components/home/HomeHeaderContainer.tsx
var HomeHeaderContainer = __webpack_require__(66806);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var dist_esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./components/common/Badge.tsx
var Badge = __webpack_require__(63732);
;// CONCATENATED MODULE: ./components/common/CurationTab.tsx
function CurationTab_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CurationTab_templateObject() {
    var data = CurationTab_taggedTemplateLiteral([
        "\n  padding: 0px ",
        "px;\n  margin-bottom: ",
        "px;\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  gap: ",
        "px;\n\n  p {\n    font-size: 12px;\n    font-style: normal;\n    line-height: 12px; /* 100% */\n    text-align: right;\n  }\n\n  .active {\n    color: ",
        ";\n    font-weight: 600;\n  }\n\n  .inactive {\n    color: ",
        ";\n    font-weight: 400;\n  }\n\n  .chip-container {\n  }\n"
    ]);
    CurationTab_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var childCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(CurationTab_templateObject(), esm/* Spacing.medium */.Ki.medium, esm/* Spacing.xxsmall */.Ki.xxsmall, esm/* Spacing.small */.Ki.small, theme.colors.main500, theme.var.gray400);
};
var CurationTab = function(param) {
    var sections = param.sections, onClickSection = param.onClickSection, selectedSectionId = param.selectedSectionId;
    var handleClickSection = function(section) {
        onClickSection(section);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: childCSS,
        children: sections === null || sections === void 0 ? void 0 : sections.map(function(childSection) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: "chip-container",
                onClick: function() {
                    return handleClickSection(childSection);
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    className: selectedSectionId === (childSection === null || childSection === void 0 ? void 0 : childSection.id) ? "active" : "inactive",
                    children: childSection.name
                })
            }, childSection === null || childSection === void 0 ? void 0 : childSection.id);
        })
    });
};
/* harmony default export */ var common_CurationTab = (CurationTab);

// EXTERNAL MODULE: ./components/layout/SafeArea.tsx
var SafeArea = __webpack_require__(45861);
// EXTERNAL MODULE: ./components/common/ListItem.tsx
var ListItem = __webpack_require__(92626);
// EXTERNAL MODULE: ./utils/analytics.ts
var analytics = __webpack_require__(3263);
// EXTERNAL MODULE: ./utils/webview.ts
var webview = __webpack_require__(81946);
// EXTERNAL MODULE: ./components/stories/Story.tsx + 2 modules
var Story = __webpack_require__(1028);
;// CONCATENATED MODULE: ./components/stories/RRViewList.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function RRViewList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RRViewList_templateObject() {
    var data = RRViewList_taggedTemplateLiteral([
        "\n  padding: ",
        "px ",
        "px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n\n  ",
        " {\n    grid-template-columns: repeat(4, 1fr);\n    padding: ",
        "px ",
        "px;\n  }\n  ",
        " {\n    grid-template-columns: repeat(5, 1fr);\n    padding: ",
        "px ",
        "px;\n  }\n\n  .card {\n    width: calc(100%);\n    aspect-ratio: 1;\n\n    .badge-container {\n      position: absolute;\n      width: 60px;\n      height: 20px;\n      text-align: center;\n      left: -16px;\n      ",
        ";\n    }\n  }\n"
    ]);
    RRViewList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var rrCSS = (0,emotion_react_browser_esm.css)(RRViewList_templateObject(), esm/* Spacing.xsmall */.Ki.xsmall, esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, esm/* Spacing.xsmall */.Ki.xsmall, esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, esm/* Spacing.xsmall */.Ki.xsmall, esm/* Spacing.xxlarge */.Ki.xxlarge, esm/* Typography.body11 */.ZT.body11);
var RRViewList = function(param) {
    var isShowAd = param.isShowAd, ad = param.ad, badgePreset = param.badgePreset, curation = param.curation, onClickMore = param.onClickMore;
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var openPageOrMove = (0,webview/* useWebView */.B9)().openPageOrMove;
    var lastIdx = curation.length - 1;
    var handleClick = function(url) {
        openPageOrMove(url);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: rrCSS,
        children: [
            isShowAd && !!(ad === null || ad === void 0 ? void 0 : ad.story) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                newTab: true,
                hideArrow: true,
                onClick: function() {
                    handleClick("/stories/".concat(ad.story.id));
                    firebase.logEvent("story_ad_click", {
                        storyId: ad.story.id,
                        storyAdId: ad.id,
                        where: "curation"
                    });
                },
                left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: "card",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Story/* RRStoryCard */.DE, _objectSpreadProps(_objectSpread({}, ad === null || ad === void 0 ? void 0 : ad.story), {
                        overlay: false,
                        isAd: true,
                        badgePreset: badgePreset
                    }))
                })
            }),
            curation === null || curation === void 0 ? void 0 : curation.map(function(item, index) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                    newTab: true,
                    hideArrow: true,
                    onClick: index === lastIdx ? onClickMore : function() {
                        handleClick(item.theme === constants/* StoryTheme.iknow */.xb.iknow ? "/stories/".concat(item.id, "/licensed") : "/stories/".concat(item.id));
                    },
                    left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: "card",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Story/* RRStoryCard */.DE, _objectSpreadProps(_objectSpread({}, item), {
                            rank: index + 1,
                            overlay: index === lastIdx,
                            width: "calc(33.333% - 16px)"
                        }))
                    })
                }, item.id + index.toString());
            })
        ]
    });
};
/* harmony default export */ var stories_RRViewList = (RRViewList);

;// CONCATENATED MODULE: ./components/stories/RSViewList.tsx
function RSViewList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RSViewList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RSViewList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function RSViewList_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function RSViewList_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        RSViewList_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function RSViewList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RSViewList_templateObject() {
    var data = RSViewList_taggedTemplateLiteral([
        "\n  display: grid;\n  margin-top: ",
        "px;\n  padding: 0px ",
        "px;\n  gap: ",
        "px;\n\n  ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n    padding: 0px ",
        "px;\n  }\n  ",
        " {\n    padding: 0px ",
        "px;\n  }\n"
    ]);
    RSViewList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var containerCSS = (0,emotion_react_browser_esm.css)(RSViewList_templateObject(), esm/* Spacing.small */.Ki.small, esm/* Spacing.medium */.Ki.medium, esm/* Spacing.xsmall */.Ki.xsmall, css/* media.tablet */.BC.tablet, esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, esm/* Spacing.xxlarge */.Ki.xxlarge);
var RSViewList = function(param) {
    var isShowAd = param.isShowAd, ad = param.ad, badgePreset = param.badgePreset, curation = param.curation;
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var openPageOrMove = (0,webview/* useWebView */.B9)().openPageOrMove;
    var handleClick = function(url) {
        openPageOrMove(url);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: containerCSS,
        children: [
            isShowAd && !!(ad === null || ad === void 0 ? void 0 : ad.story) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                newTab: true,
                hideArrow: true,
                className: "br-bottom",
                onClick: function() {
                    var ref;
                    handleClick("/stories/".concat(ad.story.id));
                    firebase.logEvent("story_ad_click", {
                        storyId: (ref = ad.story) === null || ref === void 0 ? void 0 : ref.id,
                        storyAdId: ad === null || ad === void 0 ? void 0 : ad.id,
                        where: "curation"
                    });
                },
                left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Story/* RSStoryCard */.di, RSViewList_objectSpreadProps(RSViewList_objectSpread({}, ad.story), {
                    isLibrary: true,
                    label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, RSViewList_objectSpreadProps(RSViewList_objectSpread({
                        text: t("홍보")
                    }, badgePreset), {
                        fontSize: esm/* FontSizes.xxsmall */.TS.xxsmall
                    })),
                    tapCount: undefined
                }))
            }),
            curation === null || curation === void 0 ? void 0 : curation.map(function(item, index) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                    onClick: function() {
                        handleClick(item.theme === constants/* StoryTheme.iknow */.xb.iknow ? "/stories/".concat(item.id, "/licensed") : "/stories/".concat(item.id));
                    },
                    newTab: true,
                    className: "br-bottom",
                    hideArrow: true,
                    left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Story/* RSStoryCard */.di, RSViewList_objectSpreadProps(RSViewList_objectSpread({}, item), {
                        tapCount: undefined,
                        isLibrary: false
                    }))
                }, index.toString() + item.id + "RSViewList");
            })
        ]
    });
};
/* harmony default export */ var stories_RSViewList = (RSViewList);

// EXTERNAL MODULE: ./components/common/NativeInFeedAd.tsx
var NativeInFeedAd = __webpack_require__(80521);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/form/index.js + 4 modules
var components_form = __webpack_require__(61527);
// EXTERNAL MODULE: ./.yarn/cache/axios-npm-0.25.0-a1c287d287-2a8a3787c0.zip/node_modules/axios/index.js
var axios = __webpack_require__(79825);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./components/characters/SwipeableCharacterList.tsx
var SwipeableCharacterList = __webpack_require__(83280);
// EXTERNAL MODULE: ./components/common/Modal.tsx
var Modal = __webpack_require__(59585);
// EXTERNAL MODULE: ./components/common/Button.tsx
var Button = __webpack_require__(38945);
// EXTERNAL MODULE: ./components/common/Loading.tsx
var Loading = __webpack_require__(30208);
// EXTERNAL MODULE: ./api/chatbot.ts
var chatbot = __webpack_require__(23082);
// EXTERNAL MODULE: ./api/episode.ts
var episode = __webpack_require__(58371);
// EXTERNAL MODULE: ./api/story.ts
var api_story = __webpack_require__(10741);
// EXTERNAL MODULE: ./utils/hook.ts
var hook = __webpack_require__(97033);
;// CONCATENATED MODULE: ./components/modal/FreeChatEpisodeSelectModal.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function FreeChatEpisodeSelectModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FreeChatEpisodeSelectModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FreeChatEpisodeSelectModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FreeChatEpisodeSelectModal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function FreeChatEpisodeSelectModal_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        FreeChatEpisodeSelectModal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function FreeChatEpisodeSelectModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function FreeChatEpisodeSelectModal_templateObject() {
    var data = FreeChatEpisodeSelectModal_taggedTemplateLiteral([
        "\n  max-height: 70vh;\n  overflow: auto;\n\n  .modal-title {\n    text-align: center;\n    margin-bottom: 4px;\n    font-weight: 700;\n    ",
        ";\n    background: linear-gradient(56.96deg, #04c8d0 19.7%, #1590d4 80.3%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n\n  .modal-subtitle {\n    text-align: center;\n    color: ",
        ";\n    margin-bottom: 16px;\n    ",
        ";\n  }\n\n  .episode-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 16px;\n    max-height: 40vh;\n    overflow-y: auto;\n  }\n\n  .episode-item {\n    display: flex;\n    align-items: center;\n    padding: 12px;\n    border-radius: ",
        "px;\n    border: 1.5px solid ",
        ";\n    cursor: pointer;\n    transition: all 0.15s;\n\n    &.selected {\n      border-color: ",
        ";\n      background: rgba(4, 200, 208, 0.08);\n    }\n\n    .episode-title {\n      ",
        ";\n      font-weight: 500;\n      color: ",
        ";\n      flex: 1;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    .episode-order {\n      ",
        ";\n      font-weight: 600;\n      color: ",
        ";\n      margin-right: 8px;\n      flex-shrink: 0;\n    }\n\n    &.selected .episode-title,\n    &.selected .episode-order {\n      color: ",
        ";\n    }\n  }\n\n  .loading-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 32px 0;\n    gap: 12px;\n\n    .loading-text {\n      ",
        ";\n      color: ",
        ";\n    }\n  }\n\n  .empty-message {\n    text-align: center;\n    color: ",
        ";\n    padding: 24px 0;\n    ",
        ";\n  }\n\n  .character-container {\n    height: 70px;\n    padding: 0;\n  }\n\n  .input-container {\n    padding: ",
        "px 0 1px 0;\n    .text-form {\n      padding: 10px 12px;\n      min-height: 39px;\n      background: ",
        ";\n    }\n    .text-form textarea::placeholder {\n      color: ",
        ";\n    }\n  }\n\n  .preset-selector {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 12px;\n  }\n\n  .desc {\n    text-align: center;\n    color: ",
        ";\n    margin-bottom: ",
        "px;\n    font-weight: 400;\n    ",
        ";\n\n    .price-highlight {\n      font-size: 13px;\n      font-weight: 700;\n      background: linear-gradient(56.96deg, #04c8d0 19.7%, #1590d4 80.3%);\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-clip: text;\n    }\n  }\n\n  .free-badge {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 2px;\n    margin: 0 auto 8px;\n    padding: 8px 16px;\n    border-radius: 20px;\n    background: linear-gradient(\n      56.96deg,\n      rgba(4, 200, 208, 0.12) 19.7%,\n      rgba(21, 144, 212, 0.12) 80.3%\n    );\n    width: fit-content;\n\n    span {\n      ",
        ";\n      font-weight: 600;\n      background: linear-gradient(56.96deg, #04c8d0 19.7%, #1590d4 80.3%);\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-clip: text;\n    }\n\n    .free-badge-sub {\n      ",
        ";\n      font-weight: 400;\n      color: ",
        ";\n      -webkit-text-fill-color: ",
        ";\n      background: none;\n    }\n  }\n\n  .btn-row {\n    display: flex;\n    flex-direction: column;\n    margin-top: 12px;\n\n    button {\n      box-shadow: none;\n    }\n\n    .send-btn {\n      margin-bottom: ",
        "px;\n    }\n  }\n"
    ]);
    FreeChatEpisodeSelectModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = FreeChatEpisodeSelectModal_taggedTemplateLiteral([
        "\n    flex: 1;\n    padding: 10px 12px;\n    border-radius: ",
        "px;\n    border: 1.5px solid\n      ",
        ";\n    background: ",
        ";\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.15s;\n\n    .preset-name {\n      ",
        ";\n      font-weight: 600;\n      color: ",
        ";\n    }\n    .preset-price {\n      ",
        ";\n      font-weight: 600;\n      margin-top: 2px;\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















var FreeChatEpisodeSelectModal_containerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(FreeChatEpisodeSelectModal_templateObject(), esm/* Typography.h4_sentence */.ZT.h4_sentence, theme.var.gray500, esm/* Typography.body12_sentence */.ZT.body12_sentence, esm/* Radius.medium */.wU.medium, theme.border.light, theme.colors.main500, esm/* Typography.body14 */.ZT.body14, theme.var.gray800, esm/* Typography.body12 */.ZT.body12, theme.var.gray400, theme.colors.main500, esm/* Typography.body12 */.ZT.body12, theme.var.gray500, theme.var.gray400, esm/* Typography.body14 */.ZT.body14, esm/* Spacing.small */.Ki.small, theme.var.gray100, theme.var.gray400, theme.var.gray500, esm/* Spacing.xsmall */.Ki.xsmall, esm/* Typography.body10 */.ZT.body10, esm/* Typography.body12 */.ZT.body12, esm/* Typography.body10 */.ZT.body10, theme.var.gray500, theme.var.gray500, esm/* Spacing.small */.Ki.small);
};
var presetBtnCSS = function(isSelected) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject1(), esm/* Radius.medium */.wU.medium, isSelected ? theme.colors.main500 : theme.border.light, isSelected ? "rgba(4, 200, 208, 0.08)" : theme.var.white, esm/* Typography.body14 */.ZT.body14, isSelected ? theme.colors.main500 : theme.var.gray600, esm/* Typography.body10 */.ZT.body10, isSelected ? theme.colors.main500 : theme.var.gray400);
    };
};
var FreeChatEpisodeSelectModal = function(_param) {
    var story = _param.story, props = _objectWithoutProperties(_param, [
        "story"
    ]);
    var ref;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var ref1 = (0,webview/* useWebView */.B9)(), openPageOrMove = ref1.openPageOrMove, web = ref1.web;
    var ref2 = (0,hook/* useMe */.Pi)(), me = ref2.data;
    var scrollYRef = (0,react.useRef)(0);
    (0,react.useEffect)(function() {
        if (props.open) {
            scrollYRef.current = window.scrollY;
            web.setIsBottomInputPage(true);
            document.body.style.position = "fixed";
            document.body.style.top = "-".concat(scrollYRef.current, "px");
            document.body.style.width = "100%";
        } else if (document.body.style.position === "fixed") {
            web.setIsBottomInputPage(false);
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            window.scrollTo(0, scrollYRef.current);
        }
        return function() {
            if (document.body.style.position === "fixed") {
                web.setIsBottomInputPage(false);
                document.body.style.position = "";
                document.body.style.top = "";
                document.body.style.width = "";
                window.scrollTo(0, scrollYRef.current);
            }
        };
    }, [
        props.open,
        web
    ]);
    var open = props.open;
    var ref3 = (0,react.useState)("episode-select"), step = ref3[0], setStep = ref3[1];
    var ref4 = (0,react.useState)(null), selectedEpisode = ref4[0], setSelectedEpisode = ref4[1];
    var ref5 = (0,react.useState)(false), isLoadingCharacters = ref5[0], setIsLoadingCharacters = ref5[1];
    // Chat input state
    var ref6 = (0,react.useState)([]), characters = ref6[0], setCharacters = ref6[1];
    var ref7 = (0,react.useState)(null), selectedCharacter = ref7[0], setSelectedCharacter = ref7[1];
    var ref8 = (0,react.useState)(null), chatieData = ref8[0], setChatieData = ref8[1];
    var ref9 = (0,react.useState)(""), value = ref9[0], setValue = ref9[1];
    var ref10 = (0,react.useState)(null), selectedPreset = ref10[0], setSelectedPreset = ref10[1];
    var ref11;
    // Queries
    var ref12 = (0,es.useQuery)(constants/* QUERY_KEYS.STORY.EPISODE_LIST */.U7.STORY.EPISODE_LIST((ref11 = story === null || story === void 0 ? void 0 : story.id) !== null && ref11 !== void 0 ? ref11 : 0, "oldest"), function() {
        return (0,episode/* fetchEpisodes */.lN)(story.id, "oldest", 1, 100);
    }, {
        enabled: open && !!(story === null || story === void 0 ? void 0 : story.id),
        suspense: false
    }), episodesData = ref12.data, isLoadingEpisodes = ref12.isLoading;
    var ref13 = (0,es.useQuery)(constants/* QUERY_KEYS.CHAT_ROOM.PRESETS */.U7.CHAT_ROOM.PRESETS("episode-chat"), function() {
        return (0,chatbot/* fetchDisplayPresets */.ib)("episode-chat");
    }, {
        suspense: false,
        enabled: !!me
    }), presets = ref13.data;
    var ref14 = (0,es.useMutation)(api_story/* postStoryChatRoom */.rI), createChatRoom = ref14.mutateAsync;
    var ref15;
    var episodes = (ref15 = episodesData === null || episodesData === void 0 ? void 0 : (ref = episodesData.items) === null || ref === void 0 ? void 0 : ref.filter(function(ep) {
        return ep.isFree;
    })) !== null && ref15 !== void 0 ? ref15 : [];
    var ref16;
    var hasMultiplePresets = ((ref16 = presets === null || presets === void 0 ? void 0 : presets.length) !== null && ref16 !== void 0 ? ref16 : 0) > 1;
    var hasFreePreset = presets === null || presets === void 0 ? void 0 : presets.some(function(p) {
        var _discount_message_price;
        var price = (_discount_message_price = p.discount_message_price) !== null && _discount_message_price !== void 0 ? _discount_message_price : p.message_price;
        return price === 0;
    });
    var _discount_message_price;
    var selectedPrice = selectedPreset ? (_discount_message_price = selectedPreset.discount_message_price) !== null && _discount_message_price !== void 0 ? _discount_message_price : selectedPreset.message_price : 79;
    // Reset on close
    (0,react.useEffect)(function() {
        if (!open) {
            setStep("episode-select");
            setSelectedEpisode(null);
            setCharacters([]);
            setSelectedCharacter(null);
            setChatieData(null);
            setValue("");
            setSelectedPreset(null);
        }
    }, [
        open
    ]);
    // Auto-select first episode
    (0,react.useEffect)(function() {
        if (episodes.length && !selectedEpisode && step === "episode-select") {
            setSelectedEpisode(episodes[0]);
        }
    }, [
        episodes
    ]);
    // Auto-select default preset
    (0,react.useEffect)(function() {
        if ((presets === null || presets === void 0 ? void 0 : presets.length) && !selectedPreset) {
            var defaultIdx = presets.findIndex(function(p) {
                return p.is_selected;
            });
            setSelectedPreset(defaultIdx > -1 ? presets[defaultIdx] : presets[0]);
        }
    }, [
        presets
    ]);
    var handleSelectEpisode = function() {
        var _ref = _asyncToGenerator(function() {
            var ref, ref1, episodeDetail, content, ref2, draft, result, err, ref3, status;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!selectedEpisode || !story) return [
                            2
                        ];
                        setIsLoadingCharacters(true);
                        setStep("chat-input");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            6,
                            7
                        ]);
                        return [
                            4,
                            (0,episode/* fetchEpisode */.kN)(story.id, selectedEpisode.id)
                        ];
                    case 2:
                        episodeDetail = _state.sent();
                        content = episodeDetail.content;
                        if (!(content === null || content === void 0 ? void 0 : (ref = content.attachment) === null || ref === void 0 ? void 0 : ref.url)) {
                            setStep("episode-select");
                            setIsLoadingCharacters(false);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            axios_default().get(content.attachment.url)
                        ];
                    case 3:
                        ref2 = _state.sent(), draft = ref2.data;
                        setChatieData(draft);
                        return [
                            4,
                            (0,api_story/* createAvailableCharacter */._$)(draft)
                        ];
                    case 4:
                        result = _state.sent();
                        if (result === null || result === void 0 ? void 0 : (ref1 = result.characters) === null || ref1 === void 0 ? void 0 : ref1.length) {
                            setCharacters(result.characters);
                            setSelectedCharacter(result.characters[0]);
                        }
                        return [
                            3,
                            7
                        ];
                    case 5:
                        err = _state.sent();
                        console.error("[FreeChatModal] Failed to load characters:", err);
                        status = err === null || err === void 0 ? void 0 : (ref3 = err.response) === null || ref3 === void 0 ? void 0 : ref3.status;
                        if (status === 400) {
                            alert(t("이 회차에는 캐릭터가 부족해요. 다른 회차를 선택해주세요."));
                        } else {
                            alert(t("오류가 발생했어요. 잠시 후 다시 시도해주세요."));
                        }
                        setStep("episode-select");
                        return [
                            3,
                            7
                        ];
                    case 6:
                        setIsLoadingCharacters(false);
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelectEpisode() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSend = function() {
        if (!selectedCharacter || !value || !story || !selectedEpisode || !chatieData) return;
        var payload = {
            story_id: story.id,
            episode_id: selectedEpisode.id,
            episode_json: chatieData,
            profile_uuid: selectedCharacter.id
        };
        createChatRoom(payload, {
            onSuccess: function onSuccess(data) {
                props.onClose();
                setTimeout(function() {
                    var ref;
                    openPageOrMove("/stories/".concat(story.id, "/episodes/").concat(selectedEpisode.id, "/chat-rooms/").concat(data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.id, "/?first_message=").concat(encodeURIComponent(value), "&title=").concat(encodeURIComponent(story.title)).concat(selectedPreset ? "&preset_id=".concat(selectedPreset.id) : ""));
                }, 150);
            },
            onError: function onError() {
                alert(t("잠시 후 다시 시도해주세요."));
            }
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* default */.ZP, FreeChatEpisodeSelectModal_objectSpreadProps(FreeChatEpisodeSelectModal_objectSpread({}, props), {
        header: false,
        hideCloseButton: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            css: FreeChatEpisodeSelectModal_containerCSS,
            children: [
                step === "episode-select" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                            className: "modal-title",
                            children: t("무료로 대화해보세요!")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                            className: "modal-subtitle",
                            children: t("대화할 회차를 선택하세요")
                        }),
                        isLoadingEpisodes ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            className: "loading-container",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Loading/* default */.ZP, {})
                        }) : episodes.length === 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                            className: "empty-message",
                            children: t("대화 가능한 회차가 없습니다.")
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            className: "episode-list",
                            children: episodes.map(function(ep, idx) {
                                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                    className: "episode-item ".concat((selectedEpisode === null || selectedEpisode === void 0 ? void 0 : selectedEpisode.id) === ep.id ? "selected" : ""),
                                    onClick: function() {
                                        return setSelectedEpisode(ep);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("span", {
                                            className: "episode-order",
                                            children: [
                                                idx + 1,
                                                "화"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                            className: "episode-title",
                                            children: ep.title
                                        })
                                    ]
                                }, ep.id);
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            className: "btn-row",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                                    className: "send-btn",
                                    onClick: handleSelectEpisode,
                                    text: t("다음"),
                                    disabled: !selectedEpisode
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                                    type: "text",
                                    text: t("닫기"),
                                    onClick: function() {
                                        return props.onClose();
                                    }
                                })
                            ]
                        })
                    ]
                }),
                step === "chat-input" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                    children: isLoadingCharacters ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: "loading-container",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Loading/* default */.ZP, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                className: "loading-text",
                                children: t("캐릭터를 불러오고 있어요...")
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                        children: [
                            hasFreePreset && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                className: "free-badge",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("span", {
                                        children: [
                                            "\uD83C\uDF89 ",
                                            t("무료로 새로운 대화모드가 나왔어요!")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                        className: "free-badge-sub",
                                        children: t("종료 시기 미정 \xb7 지금 바로 체험해보세요")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                className: "modal-title",
                                children: t("".concat(me === null || me === void 0 ? void 0 : me.nickname, " 님은\n지금부터 이 장면 속으로 들어갑니다."))
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                className: "modal-subtitle",
                                children: t("내가 빙의하고 싶은 주인공 중 한 명을 골라\n하고 싶은 말을 적어보세요.")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SwipeableCharacterList/* default */.Z, {
                                characterList: characters,
                                selectedCharacter: selectedCharacter,
                                onClickCharacter: function(character) {
                                    return setSelectedCharacter(character);
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: "input-container",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_form/* Textarea */.gx, {
                                    className: "text-form",
                                    fontSize: 14,
                                    value: value,
                                    onChange: function(e) {
                                        return setValue(e.target.value);
                                    },
                                    placeholder: t("이 장면의 주인공이 된다면 뭐라고 말할까요?")
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                className: "btn-row",
                                children: [
                                    hasMultiplePresets && presets && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                        className: "preset-selector",
                                        children: presets.map(function(preset) {
                                            var _discount_message_price;
                                            var price = (_discount_message_price = preset.discount_message_price) !== null && _discount_message_price !== void 0 ? _discount_message_price : preset.message_price;
                                            var isFree = price === 0;
                                            var isSelected = (selectedPreset === null || selectedPreset === void 0 ? void 0 : selectedPreset.id) === preset.id;
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                                css: presetBtnCSS(isSelected),
                                                onClick: function() {
                                                    return setSelectedPreset(preset);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                        className: "preset-name",
                                                        children: isFree ? t("무료모델") : preset.name
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                        className: "preset-price",
                                                        children: isFree ? t("0풍선") : t("".concat(price, "풍선"))
                                                    })
                                                ]
                                            }, preset.id);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                        className: "desc",
                                        children: [
                                            t("무료 대화권 보유 시 먼저 사용되며, 이후 메시지당 "),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("span", {
                                                className: "price-highlight",
                                                children: [
                                                    selectedPrice,
                                                    "풍선"
                                                ]
                                            }),
                                            t("이 차감돼요.")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                                        className: "send-btn",
                                        onClick: handleSend,
                                        text: t("장면 속에 들어가기 \uD83D\uDC40"),
                                        disabled: !value || value.length < 2 || !selectedCharacter
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                                        type: "text",
                                        text: t("뒤로"),
                                        onClick: function() {
                                            setStep("episode-select");
                                            setCharacters([]);
                                            setSelectedCharacter(null);
                                            setChatieData(null);
                                            setValue("");
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var modal_FreeChatEpisodeSelectModal = (FreeChatEpisodeSelectModal);

;// CONCATENATED MODULE: ./components/stories/SRViewList.tsx
function SRViewList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SRViewList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SRViewList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SRViewList_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SRViewList_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SRViewList_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SRViewList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SRViewList_templateObject() {
    var data = SRViewList_taggedTemplateLiteral([
        "\n  display: grid;\n  gap: 0;\n\n  ",
        " {\n    grid-template-columns: repeat(3, 1fr);\n    padding: 0px ",
        "px;\n  }\n  ",
        " {\n    grid-template-columns: repeat(4, 1fr);\n    padding: 0px ",
        "px;\n  }\n\n  & > * {\n    min-width: 0;\n    overflow: hidden;\n  }\n"
    ]);
    SRViewList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SRViewList_templateObject1() {
    var data = SRViewList_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 8px 10px;\n  border-radius: 14px;\n  background: linear-gradient(\n    56.96deg,\n    rgba(4, 200, 208, 0.12) 19.7%,\n    rgba(21, 144, 212, 0.12) 80.3%\n  );\n  cursor: pointer;\n  margin: 6px ",
        "px 4px;\n\n  span {\n    ",
        ";\n    font-weight: 600;\n    background: linear-gradient(56.96deg, #04c8d0 19.7%, #1590d4 80.3%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    white-space: nowrap;\n  }\n"
    ]);
    SRViewList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var SRViewList_containerCSS = (0,emotion_react_browser_esm.css)(SRViewList_templateObject(), css/* media.tablet */.BC.tablet, esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, esm/* Spacing.xxlarge */.Ki.xxlarge);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var freeChatCtaCSS = function(_theme) {
    return (0,emotion_react_browser_esm.css)(SRViewList_templateObject1(), esm/* Spacing.medium */.Ki.medium, esm/* Typography.body12 */.ZT.body12);
};
var SRViewList = function(param) {
    var isShowAd = param.isShowAd, ad = param.ad, badgePreset = param.badgePreset, curation = param.curation, _showNativeAd = param.showNativeAd, showNativeAd = _showNativeAd === void 0 ? false : _showNativeAd, _showFreeChatCta = param.showFreeChatCta, showFreeChatCta = _showFreeChatCta === void 0 ? false : _showFreeChatCta;
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var openPageOrMove = (0,webview/* useWebView */.B9)().openPageOrMove;
    var ref = (0,react.useState)(null), selectedStory = ref[0], setSelectedStory = ref[1];
    var ref1 = (0,react.useState)(false), isFreeChatModalOpen = ref1[0], setFreeChatModalOpen = ref1[1];
    var handleClick = function(url) {
        openPageOrMove(url);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: SRViewList_containerCSS,
        children: [
            isShowAd && !!(ad === null || ad === void 0 ? void 0 : ad.story) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                newTab: true,
                hideArrow: true,
                onClick: function() {
                    handleClick("/stories/".concat(ad.story.id));
                    firebase.logEvent("story_ad_click", {
                        storyId: ad.story.id,
                        storyAdId: ad.id,
                        where: "curation"
                    });
                },
                left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Story/* SRStoryCard */.FW, SRViewList_objectSpreadProps(SRViewList_objectSpread({}, ad.story), {
                    label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, SRViewList_objectSpread({
                        text: t("홍보")
                    }, badgePreset))
                }))
            }),
            curation === null || curation === void 0 ? void 0 : curation.map(function(item, index) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                            newTab: true,
                            onClick: function() {
                                handleClick(item.theme === constants/* StoryTheme.iknow */.xb.iknow ? "/stories/".concat(item.id, "/licensed") : "/stories/".concat(item.id));
                            },
                            hideArrow: true,
                            left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Story/* SRStoryCard */.FW, SRViewList_objectSpreadProps(SRViewList_objectSpread({}, item), {
                                rank: index + 1
                            }))
                        }),
                        showFreeChatCta && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            css: freeChatCtaCSS,
                            onClick: function(e) {
                                e.stopPropagation();
                                setSelectedStory(item);
                                setFreeChatModalOpen(true);
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("span", {
                                children: [
                                    "✨ ",
                                    t("무제한 무료! 작품 속 캐릭터와 대화하기")
                                ]
                            })
                        })
                    ]
                }, item.id + index.toString() + "SRViewList");
            }),
            showNativeAd && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NativeInFeedAd/* default */.Z, {
                unitKey: "home_sr_mobile"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(modal_FreeChatEpisodeSelectModal, {
                name: "free-chat-episode-select-modal",
                open: isFreeChatModalOpen,
                onClose: function() {
                    return setFreeChatModalOpen(false);
                },
                story: selectedStory
            })
        ]
    });
};
/* harmony default export */ var stories_SRViewList = (SRViewList);

// EXTERNAL MODULE: ./components/common/EFinderImage.tsx
var EFinderImage = __webpack_require__(11247);
// EXTERNAL MODULE: ./components/common/SwipableListContainer.tsx
var SwipableListContainer = __webpack_require__(95728);
;// CONCATENATED MODULE: ./components/stories/WFViewList.tsx
function WFViewList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function WFViewList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            WFViewList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function WFViewList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function WFViewList_templateObject() {
    var data = WFViewList_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    WFViewList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WFViewList_templateObject1() {
    var data = WFViewList_taggedTemplateLiteral([
        "\n  top: 0;\n  right: 0;\n  padding-top: ",
        "px;\n  padding-right: ",
        "px;\n"
    ]);
    WFViewList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = WFViewList_taggedTemplateLiteral([
        "\n  display: inline-block;\n  width: 120px;\n  .title {\n    ",
        ";\n  }\n  .nickname {\n    ",
        ";\n\n    color: ",
        ";\n  }\n  .info-container {\n    background: ",
        ";\n    border-radius: 0px 0px 4px 4px;\n    padding: ",
        "px;\n    gap: ",
        "px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = WFViewList_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 120px;\n  height: 90px;\n  overflow: hidden;\n  flex-shrink: 0;\n  border-radius: 4px 4px 4px 4px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = WFViewList_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  grid-template-rows: repeat(",
        ", 1fr);\n  gap: 8px;\n  padding: 8px 16px ",
        "px;\n\n  ",
        " {\n    padding: 8px ",
        "px ",
        "px;\n  }\n  ",
        " {\n    padding: 8px ",
        "px ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = WFViewList_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  margin: 0px;\n  padding: 0px;\n  border: none;\n  z-index: 9;\n\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  span {\n    border-radius: 0 3px 3px 3px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = WFViewList_taggedTemplateLiteral([
        "\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = WFViewList_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  margin-top: 6px;\n  padding: 8px 0;\n  border-radius: 4px;\n  width: 120px;\n  cursor: pointer;\n  background: ",
        ";\n  ",
        "\n\n  span {\n    ",
        ";\n    font-weight: 600;\n    background: linear-gradient(56.96deg, #04c8d0 19.7%, #1590d4 80.3%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}













var storyWrapCSS = (0,emotion_react_browser_esm.css)(WFViewList_templateObject());
var storyActionCSS = (0,emotion_react_browser_esm.css)(WFViewList_templateObject1(), esm/* Spacing.small */.Ki.small, esm/* Spacing.small */.Ki.small);
var storyCardCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject2(), esm/* Typography.h6 */.ZT.h6, esm/* Typography.body12 */.ZT.body12, theme.var.gray500, theme.var.white, esm/* Spacing.xsmall */.Ki.xsmall, esm/* Spacing.xxsmall */.Ki.xxsmall);
};
var coverImageCSS = (0,emotion_react_browser_esm.css)(_templateObject3());
var gridContainerCSS = function(rows) {
    return (0,emotion_react_browser_esm.css)(_templateObject4(), rows, esm/* Spacing.small */.Ki.small, css/* media.tablet */.BC.tablet, esm/* Spacing.xlarge */.Ki.xlarge, esm/* Spacing.small */.Ki.small, css/* media.desktop */.BC.desktop, esm/* Spacing.xxlarge */.Ki.xxlarge, esm/* Spacing.small */.Ki.small);
};
var badgeCSS = (0,emotion_react_browser_esm.css)(_templateObject5());
var freeChatCtaCPCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject7(), theme.name === "dark" ? "linear-gradient(56.96deg, rgba(4, 200, 208, 0.12) 19.7%, rgba(21, 144, 212, 0.12) 80.3%)" : theme.var.white, theme.name !== "dark" && (0,emotion_react_browser_esm.css)(_templateObject6()), esm/* Typography.body10 */.ZT.body10);
};
var WFCPViewList = function(param) {
    var stories = param.stories, hasAd = param.hasAd, ad = param.ad, badgePreset = param.badgePreset, _showFreeChatCta = param.showFreeChatCta, showFreeChatCta = _showFreeChatCta === void 0 ? false : _showFreeChatCta;
    var ref, ref1, ref2, ref3;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var openPageOrMove = (0,webview/* useWebView */.B9)().openPageOrMove;
    var ref4 = (0,react.useState)(null), selectedStory = ref4[0], setSelectedStory = ref4[1];
    var ref5 = (0,react.useState)(false), isFreeChatModalOpen = ref5[0], setFreeChatModalOpen = ref5[1];
    var handleClick = function(url) {
        openPageOrMove(url);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(SwipableListContainer/* default */.Z, {
        className: "galleryCardListContainer",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "gridContainer",
                css: gridContainerCSS(1),
                children: [
                    hasAd && !!(ad === null || ad === void 0 ? void 0 : ad.story) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
                        css: storyCardCSS,
                        onClick: function() {
                            handleClick("/stories/".concat(ad.story.id));
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                css: coverImageCSS,
                                className: "image-container",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                        css: badgeCSS,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, WFViewList_objectSpread({
                                            text: t("홍보")
                                        }, badgePreset))
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* OptimizeEFinderImage */.yK, {
                                        image: (ref = ad.story) === null || ref === void 0 ? void 0 : ref.coverImage,
                                        height: 90,
                                        width: 120,
                                        h: 54
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                className: "info-container",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                        className: "ellipsis title",
                                        children: (ref1 = ad.story) === null || ref1 === void 0 ? void 0 : ref1.title
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                        className: "ellipsis nickname",
                                        children: (ref2 = ad.story) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.nickname
                                    })
                                ]
                            })
                        ]
                    }, ad.id),
                    stories === null || stories === void 0 ? void 0 : stories.map(function(item) {
                        var id = item.id, coverImage = item.coverImage, title = item.title, user = item.user;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
                                css: storyCardCSS,
                                onClick: function() {
                                    handleClick(item.theme === constants/* StoryTheme.iknow */.xb.iknow ? "/stories/".concat(item.id, "/licensed") : "/stories/".concat(item.id));
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                        css: coverImageCSS,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Story/* StoryTag */.nH, WFViewList_objectSpread({}, item)),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* OptimizeEFinderImage */.yK, {
                                                image: coverImage,
                                                height: 90,
                                                width: 120,
                                                h: 54
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                        className: "info-container",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                className: "ellipsis title",
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                className: "ellipsis nickname",
                                                children: user === null || user === void 0 ? void 0 : user.nickname
                                            })
                                        ]
                                    }),
                                    showFreeChatCta && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                        css: freeChatCtaCPCSS,
                                        onClick: function(e) {
                                            e.stopPropagation();
                                            setSelectedStory(item);
                                            setFreeChatModalOpen(true);
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("span", {
                                            children: [
                                                "✨ ",
                                                t("무료대화하기")
                                            ]
                                        })
                                    })
                                ]
                            })
                        }, id);
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(modal_FreeChatEpisodeSelectModal, {
                name: "free-chat-episode-select-cp-modal",
                open: isFreeChatModalOpen,
                onClose: function() {
                    return setFreeChatModalOpen(false);
                },
                story: selectedStory
            })
        ]
    });
};
/* harmony default export */ var WFViewList = (WFCPViewList);

// EXTERNAL MODULE: ./utils/localStorage.ts
var localStorage = __webpack_require__(48163);
;// CONCATENATED MODULE: ./components/home/RecommendationStorySection.tsx
function RecommendationStorySection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RecommendationStorySection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RecommendationStorySection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function RecommendationStorySection_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function RecommendationStorySection_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        RecommendationStorySection_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function RecommendationStorySection_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RecommendationStorySection_templateObject() {
    var data = RecommendationStorySection_taggedTemplateLiteral([
        "\n  position: relative;\n  padding: ",
        "px ",
        "px 0px;\n  margin-bottom: ",
        " !important;\n\n  ",
        " {\n    padding: ",
        "px ",
        "px 0px;\n  }\n  ",
        " {\n    padding: ",
        "px ",
        "px 0px;\n  }\n\n  .title {\n    overflow: hidden;\n    ",
        ";\n    text-overflow: ellipsis;\n    color: ",
        ";\n  }\n\n  .more-container {\n    display: flex;\n    flex-direction: row;\n    ",
        ";\n    align-items: center;\n    min-width: 53px;\n  }\n\n  .more {\n    color: ",
        ";\n  }\n\n  .header-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    overflow: hidden;\n    align-items: center;\n    text-align: center;\n    height: 16px;\n  }\n  .title-container {\n    text-iverflow: ellipsis;\n    overflow: hidden;\n  }\n  .left-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    .info-btn-container {\n      width: 16px;\n      margin-left: ",
        "px;\n    }\n  }\n"
    ]);
    RecommendationStorySection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RecommendationStorySection_templateObject1() {
    var data = RecommendationStorySection_taggedTemplateLiteral([
        "\n  padding-bottom: ",
        "px;\n\n  ",
        " {\n    padding-bottom: ",
        "px;\n  }\n  ",
        " {\n    padding-bottom: ",
        "px;\n  }\n"
    ]);
    RecommendationStorySection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RecommendationStorySection_templateObject2() {
    var data = RecommendationStorySection_taggedTemplateLiteral([
        "\n  background: ",
        ";\n\n  .gridContainer {\n    padding-bottom: ",
        "px !important;\n  }\n  article > div:first-of-type {\n    border-radius: 4px 4px 0px 0px;\n  }\n"
    ]);
    RecommendationStorySection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


















var storyCurationCSS = function(hasChildren) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(RecommendationStorySection_templateObject(), esm/* Spacing.medium */.Ki.medium, esm/* Spacing.medium */.Ki.medium, hasChildren ? " ".concat(esm/* Spacing.small */.Ki.small, "px;") : "".concat(esm/* Spacing.xxsmall */.Ki.xxsmall, "px"), css/* media.tablet */.BC.tablet, esm/* Spacing.medium */.Ki.medium, esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, esm/* Spacing.medium */.Ki.medium, esm/* Spacing.xxlarge */.Ki.xxlarge, esm/* Typography.h5 */.ZT.h5, theme.var.black, esm/* Typography.body14 */.ZT.body14, theme.var.gray400, esm/* Spacing.xsmall */.Ki.xsmall);
    };
};
var contentWrapCSS = (0,emotion_react_browser_esm.css)(RecommendationStorySection_templateObject1(), esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, esm/* Spacing.xxlarge */.Ki.xxlarge);
var cpCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(RecommendationStorySection_templateObject2(), theme.name === "dark" ? theme.var.gray50 : "linear-gradient(190deg, transparent 35.5%, ".concat(theme.colors.main500, " 36%)"), esm/* Spacing.medium */.Ki.medium);
};
var RcommendationStorySection = function(param) {
    var section = param.section, ad = param.ad, openPopupModal = param.openPopupModal, _showNativeAd = param.showNativeAd, showNativeAd = _showNativeAd === void 0 ? false : _showNativeAd, _showFreeChatCta = param.showFreeChatCta, showFreeChatCta = _showFreeChatCta === void 0 ? false : _showFreeChatCta;
    var ref;
    var viewType = section.viewType, name = section.name, id = section.id, moreViewType = section.moreViewType, hasAd = section.hasAd, hasLine = section.hasLine, popupInfoContext = section.popupInfoContext, children = section.children;
    var openPageOrMove = (0,webview/* useWebView */.B9)().openPageOrMove;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var isCPView = viewType === constants/* CurationViewType.chatiePick */.SM.chatiePick;
    var isWFView = viewType === constants/* CurationViewType.waitfree */.SM.waitfree;
    var isRSView = viewType === constants/* CurationViewType.recentStory */.SM.recentStory;
    var isRRView = viewType === constants/* CurationViewType.realtimeRanking */.SM.realtimeRanking;
    var isSRView = viewType === constants/* CurationViewType.storyRanking */.SM.storyRanking;
    var hasMore = !!(section === null || section === void 0 ? void 0 : section.moreViewType);
    var btnInfoEvent = !!(popupInfoContext === null || popupInfoContext === void 0 ? void 0 : popupInfoContext.title);
    var hasStoryOrChildren = !!(section === null || section === void 0 ? void 0 : (ref = section.stories) === null || ref === void 0 ? void 0 : ref.length) || !!(children === null || children === void 0 ? void 0 : children.length);
    var ref1 = (0,react.useState)(section), selctedSectionItem = ref1[0], setSelectedSectionItem = ref1[1];
    var grayFill = (0,Badge/* useBadgePresets */.fw)().grayFill;
    var handleClickMore = function() {
        var ref, ref1, ref2;
        var subSections = (section === null || section === void 0 ? void 0 : (ref = section.children) === null || ref === void 0 ? void 0 : ref.length) ? JSON.stringify(section === null || section === void 0 ? void 0 : (ref1 = section.children) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
            return {
                id: item.id,
                name: item.name
            };
        })) : "";
        var subSectionIndex = selctedSectionItem ? section === null || section === void 0 ? void 0 : (ref2 = section.children) === null || ref2 === void 0 ? void 0 : ref2.findIndex(function(item) {
            return item.id === (selctedSectionItem === null || selctedSectionItem === void 0 ? void 0 : selctedSectionItem.id);
        }) : 0;
        openPageOrMove("/curations/".concat(id, "?title=").concat(name, "&view_type=").concat(moreViewType, "&sub_sections=").concat(subSections, "&sub_section_index=").concat(subSectionIndex));
    };
    var handleClickChildSection = function(section) {
        setSelectedSectionItem(section);
        var prevTab = localStorage/* ParsedStorage.getItem */.f.getItem("selectedSectionTab");
        localStorage/* ParsedStorage.setItem */.f.setItem("selectedSectionTab", RecommendationStorySection_objectSpreadProps(RecommendationStorySection_objectSpread({}, prevTab), RecommendationStorySection_defineProperty({}, id, section === null || section === void 0 ? void 0 : section.id)));
    };
    (0,react.useEffect)(function() {
        if (!!(children === null || children === void 0 ? void 0 : children.length)) {
            var ref;
            var prevTab = localStorage/* ParsedStorage.getItem */.f.getItem("selectedSectionTab");
            var prevTabId = prevTab === null || prevTab === void 0 ? void 0 : prevTab[id];
            var hasPrevTabId = !!prevTabId && (section === null || section === void 0 ? void 0 : (ref = section.children) === null || ref === void 0 ? void 0 : ref.some(function(child) {
                return (child === null || child === void 0 ? void 0 : child.id) === prevTabId;
            }));
            if (hasPrevTabId) {
                var ref1;
                var prevSection = section === null || section === void 0 ? void 0 : (ref1 = section.children) === null || ref1 === void 0 ? void 0 : ref1.find(function(child) {
                    return (child === null || child === void 0 ? void 0 : child.id) === prevTabId;
                });
                setSelectedSectionItem(prevSection ? prevSection : section === null || section === void 0 ? void 0 : section.children[0]);
            } else {
                setSelectedSectionItem(section === null || section === void 0 ? void 0 : section.children[0]);
            }
        }
    }, []);
    var handleClickBtnInfo = function() {
        var title = popupInfoContext.title, description = popupInfoContext.description, tip = popupInfoContext.tip;
        openPopupModal({
            title: title,
            description: description,
            tip: tip
        });
    };
    var isShowAd = !!ad && !!hasAd && !!(ad === null || ad === void 0 ? void 0 : ad.story);
    if (!hasStoryOrChildren) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(SafeArea/* default */.Z, {
        children: [
            hasLine && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: storyCurationCSS(!!(children === null || children === void 0 ? void 0 : children.length)),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    className: "header-container",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            className: "left-container",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: "title-container",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                        className: "title ellipsis",
                                        children: name
                                    })
                                }),
                                !!btnInfoEvent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: "info-btn-container",
                                    onClick: handleClickBtnInfo,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                        icon: icon/* InfoCircle */.Zd,
                                        color: theme.colors.main500,
                                        size: esm/* Sizes.small */.u8.small
                                    })
                                })
                            ]
                        }),
                        hasMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            onClick: handleClickMore,
                            className: "more-container",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                    className: "more",
                                    children: t("더보기")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                    icon: icon/* ArrowRight */.ol,
                                    color: theme.var.gray400,
                                    size: esm/* Sizes.small */.u8.small
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: contentWrapCSS,
                children: [
                    !!(children === null || children === void 0 ? void 0 : children.length) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(common_CurationTab, {
                        sections: children,
                        onClickSection: handleClickChildSection,
                        selectedSectionId: selctedSectionItem === null || selctedSectionItem === void 0 ? void 0 : selctedSectionItem.id
                    }),
                    isSRView && hasStoryOrChildren && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(stories_SRViewList, {
                        curation: selctedSectionItem === null || selctedSectionItem === void 0 ? void 0 : selctedSectionItem.stories,
                        isShowAd: isShowAd,
                        ad: ad,
                        badgePreset: grayFill,
                        showNativeAd: showNativeAd,
                        showFreeChatCta: showFreeChatCta
                    }),
                    isRRView && hasStoryOrChildren && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(stories_RRViewList, {
                        curation: selctedSectionItem === null || selctedSectionItem === void 0 ? void 0 : selctedSectionItem.stories,
                        isShowAd: isShowAd,
                        ad: ad,
                        badgePreset: grayFill,
                        onClickMore: handleClickMore
                    }),
                    isWFView && hasStoryOrChildren && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(WFViewList, {
                        stories: selctedSectionItem === null || selctedSectionItem === void 0 ? void 0 : selctedSectionItem.stories,
                        hasAd: hasAd,
                        badgePreset: grayFill,
                        ad: ad,
                        showNativeAd: showNativeAd
                    }),
                    isCPView && hasStoryOrChildren && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        css: cpCSS,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(WFViewList, {
                            stories: selctedSectionItem === null || selctedSectionItem === void 0 ? void 0 : selctedSectionItem.stories,
                            hasAd: hasAd,
                            badgePreset: grayFill,
                            ad: ad,
                            showNativeAd: showNativeAd,
                            showFreeChatCta: showFreeChatCta
                        })
                    }),
                    isRSView && hasStoryOrChildren && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(stories_RSViewList, {
                        curation: selctedSectionItem === null || selctedSectionItem === void 0 ? void 0 : selctedSectionItem.stories,
                        isShowAd: isShowAd,
                        ad: ad,
                        badgePreset: grayFill
                    })
                ]
            }),
            hasLine && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Divider/* default */.Z, {})
        ]
    }, id);
};
/* harmony default export */ var RecommendationStorySection = (RcommendationStorySection);

// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/link.js
var next_link = __webpack_require__(46249);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./hooks/query/useWebtoonStoriesQuery.ts
var useWebtoonStoriesQuery = __webpack_require__(4831);
// EXTERNAL MODULE: ./utils/webtoon.ts
var webtoon = __webpack_require__(23043);
;// CONCATENATED MODULE: ./components/home/WebtoonStoryList.tsx
function WebtoonStoryList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function WebtoonStoryList_templateObject() {
    var data = WebtoonStoryList_taggedTemplateLiteral([
        "\n  padding-top: ",
        "px;\n"
    ]);
    WebtoonStoryList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WebtoonStoryList_templateObject1() {
    var data = WebtoonStoryList_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 ",
        "px ",
        "px;\n\n  ",
        " {\n    padding: 0 ",
        "px ",
        "px;\n  }\n\n  ",
        " {\n    padding: 0 ",
        "px ",
        "px;\n  }\n\n  .title-container {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    min-width: 0;\n  }\n\n  .title {\n    ",
        ";\n  }\n\n  .beta-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    height: 18px;\n    padding: 0 6px;\n    border-radius: 4px;\n    background: ",
        ";\n    color: ",
        ";\n    font-size: 10px;\n    font-weight: 900;\n    line-height: 1;\n  }\n\n  .more-container {\n    display: flex;\n    min-width: 53px;\n    align-items: center;\n    flex-direction: row;\n    color: ",
        ";\n    text-decoration: none;\n    ",
        ";\n  }\n\n  .more {\n    color: ",
        ";\n  }\n"
    ]);
    WebtoonStoryList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WebtoonStoryList_templateObject2() {
    var data = WebtoonStoryList_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  grid-template-rows: repeat(1, 1fr);\n  gap: 8px;\n  padding: 8px ",
        "px ",
        "px;\n\n  ",
        " {\n    padding: 8px ",
        "px ",
        "px;\n  }\n\n  ",
        " {\n    padding: 8px ",
        "px ",
        "px;\n  }\n"
    ]);
    WebtoonStoryList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WebtoonStoryList_templateObject3() {
    var data = WebtoonStoryList_taggedTemplateLiteral([
        "\n  display: inline-block;\n  width: 120px;\n  cursor: pointer;\n  color: inherit;\n  text-decoration: none;\n\n  .image {\n    position: relative;\n    width: 120px;\n    height: 90px;\n    overflow: hidden;\n    flex-shrink: 0;\n    border-radius: 4px;\n    background: ",
        ";\n  }\n\n  .placeholder {\n    display: flex;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    color: ",
        ";\n    ",
        ";\n  }\n\n  .info-container {\n    background: ",
        ";\n    border-radius: 0 0 4px 4px;\n    padding: ",
        "px;\n    gap: ",
        "px;\n  }\n\n  .title {\n    ",
        ";\n    color: ",
        ";\n  }\n\n  .nickname {\n    ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    WebtoonStoryList_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var sectionCSS = (0,emotion_react_browser_esm.css)(WebtoonStoryList_templateObject(), esm/* Spacing.medium */.Ki.medium);
var headerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(WebtoonStoryList_templateObject1(), esm/* Spacing.medium */.Ki.medium, esm/* Spacing.small */.Ki.small, css/* media.tablet */.BC.tablet, esm/* Spacing.xlarge */.Ki.xlarge, esm/* Spacing.small */.Ki.small, css/* media.desktop */.BC.desktop, esm/* Spacing.xxlarge */.Ki.xxlarge, esm/* Spacing.small */.Ki.small, esm/* Typography.h5 */.ZT.h5, theme.var.gray100, theme.var.gray600, theme.var.gray400, esm/* Typography.body14 */.ZT.body14, theme.var.gray400);
};
var listCSS = (0,emotion_react_browser_esm.css)(WebtoonStoryList_templateObject2(), esm/* Spacing.medium */.Ki.medium, esm/* Spacing.small */.Ki.small, css/* media.tablet */.BC.tablet, esm/* Spacing.xlarge */.Ki.xlarge, esm/* Spacing.small */.Ki.small, css/* media.desktop */.BC.desktop, esm/* Spacing.xxlarge */.Ki.xxlarge, esm/* Spacing.small */.Ki.small);
var cardCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(WebtoonStoryList_templateObject3(), theme.var.gray50, theme.var.gray400, esm/* Typography.body11 */.ZT.body11, theme.var.white, esm/* Spacing.xsmall */.Ki.xsmall, esm/* Spacing.xxsmall */.Ki.xxsmall, esm/* Typography.h6 */.ZT.h6, theme.var.black, esm/* Typography.body12 */.ZT.body12, theme.var.gray500);
};
var WebtoonStoryCard = function(param) {
    var href = param.href, story = param.story, onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("a", {
            css: cardCSS,
            onClick: function(event) {
                event.preventDefault();
                onClick();
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: "image",
                    children: story.coverImage ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* OptimizeEFinderImage */.yK, {
                        image: story.coverImage,
                        height: 90,
                        width: 120,
                        h: 54
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: "placeholder",
                        children: "채티 웹툰"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    className: "info-container",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                            className: "ellipsis title",
                            children: story.title
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                            className: "ellipsis nickname",
                            children: story.authorName || story.subtitle
                        })
                    ]
                })
            ]
        })
    });
};
var WebtoonStoryList = function() {
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var openPageOrMove = (0,webview/* useWebView */.B9)().openPageOrMove;
    var ref = (0,useWebtoonStoriesQuery/* useWebtoonStoriesQuery */.x)(), isMounted = ref.isMounted, webtoonStories = ref.webtoonStories;
    if (!isMounted || !webtoonStories.length) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SafeArea/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("section", {
            css: sectionCSS,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    css: headerCSS,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            className: "title-container",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                    className: "title",
                                    children: t("채티 웹툰")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                    className: "beta-badge",
                                    children: "BETA"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
                            href: "/webtoon",
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("a", {
                                className: "more-container",
                                onClick: function(event) {
                                    event.preventDefault();
                                    openPageOrMove("/webtoon");
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                        className: "more",
                                        children: t("더보기")
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                        icon: icon/* ArrowRight */.ol,
                                        color: theme.var.gray400,
                                        size: esm/* Sizes.small */.u8.small
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SwipableListContainer/* default */.Z, {
                    className: "galleryCardListContainer",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        css: listCSS,
                        children: webtoonStories.map(function(story) {
                            var path = (0,webtoon/* getWebtoonStoryPath */.yA)(story.webtoonId);
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(WebtoonStoryCard, {
                                href: path,
                                story: story,
                                onClick: function() {
                                    openPageOrMove(path);
                                }
                            }, story.webtoonId);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var home_WebtoonStoryList = (WebtoonStoryList);

// EXTERNAL MODULE: ./components/layout/Layout.tsx
var Layout = __webpack_require__(26382);
// EXTERNAL MODULE: ./components/layout/Push.tsx
var Push = __webpack_require__(23516);
// EXTERNAL MODULE: ./stores/useModalStore.ts
var useModalStore = __webpack_require__(16345);
;// CONCATENATED MODULE: ./components/modal/PopupModal.tsx
function PopupModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function PopupModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PopupModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PopupModal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function PopupModal_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        PopupModal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function PopupModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PopupModal_templateObject() {
    var data = PopupModal_taggedTemplateLiteral([
        "\n  text-align: center;\n  line-height: 18px;\n\n  .profile {\n    gap: ",
        "px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    ",
        ";\n    margin-bottom: ",
        "px;\n  }\n  p {\n    ",
        ";\n    color: ",
        ";\n    line-height: 19px;\n  }\n\n  .checkbox {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: ",
        "px;\n  }\n\n  .tip {\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    color: ",
        ";\n    ",
        ";\n    gap: 6px;\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    PopupModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var PopupModal_containerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(PopupModal_templateObject(), esm/* Spacing.medium */.Ki.medium, esm/* Typography.body14 */.ZT.body14, esm/* Spacing.small */.Ki.small, esm/* Typography.body12 */.ZT.body12, theme.var.gray900, esm/* Spacing.xlarge */.Ki.xlarge, theme.colors.main500, esm/* Typography.body11 */.ZT.body11, esm/* Spacing.medium */.Ki.medium);
};
var PopupModal = function(_param) {
    var props = _extends({}, _param);
    var onClose = props.onClose;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var map = (0,useModalStore/* useModalStore */.a)().map;
    var main = (0,Badge/* useBadgePresets */.fw)().main;
    var modalMap = map.get(props.name);
    var payload = modalMap === null || modalMap === void 0 ? void 0 : modalMap.meta;
    var ref, ref1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* default */.ZP, PopupModal_objectSpreadProps(PopupModal_objectSpread({}, props), {
        onClose: onClose,
        title: (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            css: PopupModal_containerCSS,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: "profile",
                    style: {
                        whiteSpace: "pre-line"
                    },
                    children: t((ref1 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref1 !== void 0 ? ref1 : "")
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    className: "tip",
                    children: [
                        (payload === null || payload === void 0 ? void 0 : payload.tip) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, PopupModal_objectSpreadProps(PopupModal_objectSpread({}, main), {
                            text: t("TIP")
                        })),
                        t(payload === null || payload === void 0 ? void 0 : payload.tip)
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalButton */.mH, {
                    text: t("확인했어요"),
                    onClick: function() {
                        return onClose();
                    }
                })
            ]
        })
    }));
};
/* harmony default export */ var modal_PopupModal = (PopupModal);

// EXTERNAL MODULE: ./components/skeleton/Frame.tsx
var Frame = __webpack_require__(19827);
// EXTERNAL MODULE: ./components/skeleton/PlaySkeleton.tsx
var PlaySkeleton = __webpack_require__(4223);
// EXTERNAL MODULE: ./components/skeleton/SkeletonList.tsx
var SkeletonList = __webpack_require__(6668);
// EXTERNAL MODULE: ./components/common/Empty.tsx
var Empty = __webpack_require__(34270);
// EXTERNAL MODULE: ./components/common/Pagination.tsx
var Pagination = __webpack_require__(39753);
// EXTERNAL MODULE: ./components/search/CurationBannert.tsx
var CurationBannert = __webpack_require__(65583);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
// EXTERNAL MODULE: ./utils/query.ts
var utils_query = __webpack_require__(96261);
;// CONCATENATED MODULE: ./components/stories/SectionStoryTab.tsx
function SectionStoryTab_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SectionStoryTab_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SectionStoryTab_defineProperty(target, key, source[key]);
        });
    }
    return target;
}















var SectionStoryList = function(param) {
    var sectionId = param.sectionId, screen = param.screen;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var queryKey = constants/* QUERY_KEYS.SECTION_STORY.LIST */.U7.SECTION_STORY.LIST(sectionId);
    var query = (0,utils_query/* usePaginationQuery */.Zl)(queryKey, function(param) {
        var pageParam = param.pageParam;
        return (0,common/* fetchSectionStories */.uM)(sectionId, pageParam);
    });
    var web = (0,webview/* useWebView */.B9)().web;
    (0,react.useEffect)(function() {
        if (screen) {
            web.data("screen", {
                screenName: "메인/홈/".concat(screen),
                parameters: (0,misc/* jsonStringify */.lh)(router === null || router === void 0 ? void 0 : router.query)
            });
        }
    }, [
        screen
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CurationBannert/* default */.Z, {
                sectionId: sectionId
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                name: "section-story-list",
                query: query,
                border: true,
                inFeedAd: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NativeInFeedAd/* default */.Z, {
                    unitKey: "home_cp_mobile"
                }),
                children: function(item) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListItem/* LinkItem */.nf, {
                        hideArrow: true,
                        newTab: true,
                        to: "/stories/".concat(item.id),
                        left: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Story/* default */.ZP, SectionStoryTab_objectSpread({}, item))
                    });
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Empty/* default */.Z, {
                query: query,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    children: t("작품이 없습니다.")
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./api/section.ts
var section = __webpack_require__(60381);
;// CONCATENATED MODULE: ./.yarn/cache/web-vitals-npm-4.2.3-c4cc9b1531-6d916af95a.zip/node_modules/web-vitals/dist/web-vitals.js
var e,n,t,r,i,o=-1,a=function(e){addEventListener("pageshow",(function(n){n.persisted&&(o=n.timeStamp,e(n))}),!0)},c=function(){var e=self.performance&&performance.getEntriesByType&&performance.getEntriesByType("navigation")[0];if(e&&e.responseStart>0&&e.responseStart<performance.now())return e},u=function(){var e=c();return e&&e.activationStart||0},f=function(e,n){var t=c(),r="navigate";o>=0?r="back-forward-cache":t&&(document.prerendering||u()>0?r="prerender":document.wasDiscarded?r="restore":t.type&&(r=t.type.replace(/_/g,"-")));return{name:e,value:void 0===n?-1:n,rating:"good",delta:0,entries:[],id:"v4-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12),navigationType:r}},s=function(e,n,t){try{if(PerformanceObserver.supportedEntryTypes.includes(e)){var r=new PerformanceObserver((function(e){Promise.resolve().then((function(){n(e.getEntries())}))}));return r.observe(Object.assign({type:e,buffered:!0},t||{})),r}}catch(e){}},d=function(e,n,t,r){var i,o;return function(a){n.value>=0&&(a||r)&&((o=n.value-(i||0))||void 0===i)&&(i=n.value,n.delta=o,n.rating=function(e,n){return e>n[1]?"poor":e>n[0]?"needs-improvement":"good"}(n.value,t),e(n))}},l=function(e){requestAnimationFrame((function(){return requestAnimationFrame((function(){return e()}))}))},p=function(e){document.addEventListener("visibilitychange",(function(){"hidden"===document.visibilityState&&e()}))},v=function(e){var n=!1;return function(){n||(e(),n=!0)}},m=-1,h=function(){return"hidden"!==document.visibilityState||document.prerendering?1/0:0},g=function(e){"hidden"===document.visibilityState&&m>-1&&(m="visibilitychange"===e.type?e.timeStamp:0,T())},y=function(){addEventListener("visibilitychange",g,!0),addEventListener("prerenderingchange",g,!0)},T=function(){removeEventListener("visibilitychange",g,!0),removeEventListener("prerenderingchange",g,!0)},E=function(){return m<0&&(m=h(),y(),a((function(){setTimeout((function(){m=h(),y()}),0)}))),{get firstHiddenTime(){return m}}},C=function(e){document.prerendering?addEventListener("prerenderingchange",(function(){return e()}),!0):e()},b=[1800,3e3],S=function(e,n){n=n||{},C((function(){var t,r=E(),i=f("FCP"),o=s("paint",(function(e){e.forEach((function(e){"first-contentful-paint"===e.name&&(o.disconnect(),e.startTime<r.firstHiddenTime&&(i.value=Math.max(e.startTime-u(),0),i.entries.push(e),t(!0)))}))}));o&&(t=d(e,i,b,n.reportAllChanges),a((function(r){i=f("FCP"),t=d(e,i,b,n.reportAllChanges),l((function(){i.value=performance.now()-r.timeStamp,t(!0)}))})))}))},L=(/* unused pure expression or super */ null && ([.1,.25])),w=function(e,n){n=n||{},S(v((function(){var t,r=f("CLS",0),i=0,o=[],c=function(e){e.forEach((function(e){if(!e.hadRecentInput){var n=o[0],t=o[o.length-1];i&&e.startTime-t.startTime<1e3&&e.startTime-n.startTime<5e3?(i+=e.value,o.push(e)):(i=e.value,o=[e])}})),i>r.value&&(r.value=i,r.entries=o,t())},u=s("layout-shift",c);u&&(t=d(e,r,L,n.reportAllChanges),p((function(){c(u.takeRecords()),t(!0)})),a((function(){i=0,r=f("CLS",0),t=d(e,r,L,n.reportAllChanges),l((function(){return t()}))})),setTimeout(t,0))})))},A=0,I=(/* unused pure expression or super */ null && (1/0)),P=0,M=function(e){e.forEach((function(e){e.interactionId&&(I=Math.min(I,e.interactionId),P=Math.max(P,e.interactionId),A=P?(P-I)/7+1:0)}))},k=function(){return e?A:performance.interactionCount||0},F=function(){"interactionCount"in performance||e||(e=s("event",M,{type:"event",buffered:!0,durationThreshold:0}))},D=(/* unused pure expression or super */ null && ([])),x=new Map,R=0,B=function(){var e=Math.min(D.length-1,Math.floor((k()-R)/50));return D[e]},H=(/* unused pure expression or super */ null && ([])),q=function(e){if(H.forEach((function(n){return n(e)})),e.interactionId||"first-input"===e.entryType){var n=D[D.length-1],t=x.get(e.interactionId);if(t||D.length<10||e.duration>n.latency){if(t)e.duration>t.latency?(t.entries=[e],t.latency=e.duration):e.duration===t.latency&&e.startTime===t.entries[0].startTime&&t.entries.push(e);else{var r={id:e.interactionId,latency:e.duration,entries:[e]};x.set(r.id,r),D.push(r)}D.sort((function(e,n){return n.latency-e.latency})),D.length>10&&D.splice(10).forEach((function(e){return x.delete(e.id)}))}}},O=function(e){var n=self.requestIdleCallback||self.setTimeout,t=-1;return e=v(e),"hidden"===document.visibilityState?e():(t=n(e),p(e)),t},N=(/* unused pure expression or super */ null && ([200,500])),j=function(e,n){"PerformanceEventTiming"in self&&"interactionId"in PerformanceEventTiming.prototype&&(n=n||{},C((function(){var t;F();var r,i=f("INP"),o=function(e){O((function(){e.forEach(q);var n=B();n&&n.latency!==i.value&&(i.value=n.latency,i.entries=n.entries,r())}))},c=s("event",o,{durationThreshold:null!==(t=n.durationThreshold)&&void 0!==t?t:40});r=d(e,i,N,n.reportAllChanges),c&&(c.observe({type:"first-input",buffered:!0}),p((function(){o(c.takeRecords()),r(!0)})),a((function(){R=k(),D.length=0,x.clear(),i=f("INP"),r=d(e,i,N,n.reportAllChanges)})))})))},_=[2500,4e3],z={},G=function(e,n){n=n||{},C((function(){var t,r=E(),i=f("LCP"),o=function(e){n.reportAllChanges||(e=e.slice(-1)),e.forEach((function(e){e.startTime<r.firstHiddenTime&&(i.value=Math.max(e.startTime-u(),0),i.entries=[e],t())}))},c=s("largest-contentful-paint",o);if(c){t=d(e,i,_,n.reportAllChanges);var m=v((function(){z[i.id]||(o(c.takeRecords()),c.disconnect(),z[i.id]=!0,t(!0))}));["keydown","click"].forEach((function(e){addEventListener(e,(function(){return O(m)}),!0)})),p(m),a((function(r){i=f("LCP"),t=d(e,i,_,n.reportAllChanges),l((function(){i.value=performance.now()-r.timeStamp,z[i.id]=!0,t(!0)}))}))}}))},J=(/* unused pure expression or super */ null && ([800,1800])),K=function e(n){document.prerendering?C((function(){return e(n)})):"complete"!==document.readyState?addEventListener("load",(function(){return e(n)}),!0):setTimeout(n,0)},Q=function(e,n){n=n||{};var t=f("TTFB"),r=d(e,t,J,n.reportAllChanges);K((function(){var i=c();i&&(t.value=Math.max(i.responseStart-u(),0),t.entries=[i],r(!0),a((function(){t=f("TTFB",0),(r=d(e,t,J,n.reportAllChanges))(!0)})))}))},U={passive:!0,capture:!0},V=new Date,W=function(e,i){n||(n=i,t=e,r=new Date,Z(removeEventListener),X())},X=function(){if(t>=0&&t<r-V){var e={entryType:"first-input",name:n.type,target:n.target,cancelable:n.cancelable,startTime:n.timeStamp,processingStart:n.timeStamp+t};i.forEach((function(n){n(e)})),i=[]}},Y=function(e){if(e.cancelable){var n=(e.timeStamp>1e12?new Date:performance.now())-e.timeStamp;"pointerdown"==e.type?function(e,n){var t=function(){W(e,n),i()},r=function(){i()},i=function(){removeEventListener("pointerup",t,U),removeEventListener("pointercancel",r,U)};addEventListener("pointerup",t,U),addEventListener("pointercancel",r,U)}(n,e):W(n,e)}},Z=function(e){["mousedown","keydown","touchstart","pointerdown"].forEach((function(n){return e(n,Y,U)}))},$=(/* unused pure expression or super */ null && ([100,300])),ee=function(e,r){r=r||{},C((function(){var o,c=E(),u=f("FID"),l=function(e){e.startTime<c.firstHiddenTime&&(u.value=e.processingStart-e.startTime,u.entries.push(e),o(!0))},m=function(e){e.forEach(l)},h=s("first-input",m);o=d(e,u,$,r.reportAllChanges),h&&(p(v((function(){m(h.takeRecords()),h.disconnect()}))),a((function(){var a;u=f("FID"),o=d(e,u,$,r.reportAllChanges),i=[],t=-1,n=null,Z(addEventListener),a=l,i.push(a),X()})))}))};

;// CONCATENATED MODULE: ./lib/measureWebPerf.ts
// lib/measureWebPerf.ts

function post(name, data) {
    // ① iOS 네이티브(WKWebView)로도 전달하고 싶을 때
    // try {
    //   // WebViewController에서 "perf" 핸들러를 등록해둔 경우
    //   // configuration.userContentController.add(..., name: "perf")
    //   // 와 호환됩니다.
    //   // @ts-ignore
    //   window.webkit?.messageHandlers?.perf?.postMessage?.({ type: name, data });
    // } catch {}
    // ② 콘솔에도 남김
    // eslint-disable-next-line no-console
    console.log("[PERF:".concat(name, "]"), data);
// ③ (선택) Firebase Analytics로
// window.firebase?.logEvent?.(name, data); // 프로젝트 헬퍼에 맞게 바꿔 사용
}
// NavigationTiming 수집 (초기 로드 시점)
function reportNavigationTimings() {
    var nav = performance.getEntriesByType("navigation")[0] || null;
    var ref, ref1, ref2, ref3;
    // legacy fallback
    var payload = {
        url: location.href,
        ttfb: nav && nav.responseStart - nav.startTime,
        dns: nav && nav.domainLookupEnd - nav.domainLookupStart,
        connect: nav && nav.connectEnd - nav.connectStart,
        request: nav && nav.responseStart - nav.requestStart,
        response: nav && nav.responseEnd - nav.responseStart,
        domContentLoaded: nav && (nav === null || nav === void 0 ? void 0 : nav.domContentLoadedEventEnd) - (nav === null || nav === void 0 ? void 0 : nav.startTime),
        load: nav && nav.loadEventEnd - nav.startTime,
        // 사이즈(지원 안 될 수도 있음)
        transferSize: (ref = nav === null || nav === void 0 ? void 0 : nav.transferSize) !== null && ref !== void 0 ? ref : null,
        encodedBodySize: (ref1 = nav === null || nav === void 0 ? void 0 : nav.encodedBodySize) !== null && ref1 !== void 0 ? ref1 : null,
        decodedBodySize: (ref2 = nav === null || nav === void 0 ? void 0 : nav.decodedBodySize) !== null && ref2 !== void 0 ? ref2 : null,
        redirectCount: (ref3 = nav === null || nav === void 0 ? void 0 : nav.redirectCount) !== null && ref3 !== void 0 ? ref3 : null
    };
    post("navigation", payload);
}
// Web Vitals(FCP/LCP) 수집
function reportWebVitalsBasics() {
    S(function(m) {
        post("fcp", {
            value: m.value,
            id: m.id
        });
    });
    G(function(m) {
        // 목표: LCP < 2500 (ms)
        post("lcp", {
            value: m.value,
            id: m.id,
            rating: m.value < 2500 ? "good" : m.value < 4000 ? "needs-improvement" : "poor"
        });
    });
}
// 초기 로드에서 한 번만 호출
function setupPerfReporting() {
    // 네비게이션 타이밍은 'load' 뒤에 더 정확해지므로 load 직후에 한 번
    if (document.readyState === "complete") {
        // 약간 지연해서 사이즈 필드들 채워지게
        setTimeout(reportNavigationTimings, 0);
    } else {
        window.addEventListener("load", function() {
            return setTimeout(reportNavigationTimings, 0);
        }, {
            once: true
        });
    }
    // Web Vitals는 즉시 옵저버 등록
    reportWebVitalsBasics();
}

// EXTERNAL MODULE: ./contexts/auth.tsx
var auth = __webpack_require__(71727);
// EXTERNAL MODULE: ./contexts/global.ts
var global = __webpack_require__(30259);
;// CONCATENATED MODULE: ./pages/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function pages_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function pages_templateObject() {
    var data = pages_taggedTemplateLiteral([
        "\n  overflow-x: hidden;\n"
    ]);
    pages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function pages_templateObject1() {
    var data = pages_taggedTemplateLiteral([
        "\n  // margin-top: 42px;\n  .section-container {\n    margin-top: 112px;\n  }\n"
    ]);
    pages_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function pages_templateObject2() {
    var data = pages_taggedTemplateLiteral([
        "\n  margin-top: 28px;\n  text-align: center;\n\n  .title {\n    display: flex;\n    justify-content: center;\n    gap: 2px;\n    align-items: center;\n  }\n\n  p {\n    color: ",
        ";\n    ",
        "\n  }\n"
    ]);
    pages_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function pages_templateObject3() {
    var data = pages_taggedTemplateLiteral([
        "\n    ",
        ";\n    margin: 0 auto;\n    position: relative;\n\n    .floating-wrapper {\n      display: flex;\n      flex-direction: row-reverse;\n      gap: 12px;\n      width: 100%;\n      ",
        ";\n      padding: 16px;\n      position: fixed;\n      bottom: ",
        ";\n      z-index: 99;\n\n      .floating-promo {\n        position: static;\n        display: flex;\n        flex: 1;\n        background: linear-gradient(55.29deg, #ff07f5 20.46%, #ed0064 82.76%);\n      }\n\n      .floating-create {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        align-self: flex-end;\n        position: static;\n        bottom: ",
        "px;\n        right: ",
        "px;\n        width: 64px;\n        height: 64px;\n        border-radius: ",
        "px;\n        z-index: 100;\n        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.4);\n        background-color: ",
        ";\n      }\n    }\n  "
    ]);
    pages_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function pages_templateObject4() {
    var data = pages_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    pages_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function pages_templateObject5() {
    var data = pages_taggedTemplateLiteral([
        "\n  padding-bottom: 62.5%;\n"
    ]);
    pages_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}














// import ChatieRankingStoryList from '@components/home/ChatieRankingStoryList';




// import { withAuth } from '@contexts/auth';
















var __N_SSP = true;
var HomeLoading = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Layout/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HomeHeader/* default */.Z, {
                    hasNewNotification: false,
                    isHome: true
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Frame/* default */.Z, {
                    css: bannerSkeletonCSS
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SkeletonList/* default */.Z, {
                    skeleton: PlaySkeleton/* default */.Z
                })
            ]
        })
    });
};
var ListLoading = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Frame/* default */.Z, {
                css: bannerSkeletonCSS
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SkeletonList/* default */.Z, {
                skeleton: PlaySkeleton/* default */.Z
            })
        ]
    });
};
var pages_containerCSS = (0,emotion_react_browser_esm.css)(pages_templateObject());
var homeContainerCSS = (0,emotion_react_browser_esm.css)(pages_templateObject1());
var footerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(pages_templateObject2(), theme.var.gray400, esm/* Typography.body12 */.ZT.body12);
};
var floatingButtonContainerCSS = function(isCheming) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(pages_templateObject3(), css/* responsiveMaxWidth */.S8, css/* responsiveMaxWidth */.S8, isCheming ? "".concat(Push/* PushSize.bottomTab */.z.bottomTab, "px") : "0", esm/* Spacing.medium */.Ki.medium, esm/* Spacing.medium */.Ki.medium, esm/* Radius.round */.wU.round, theme.colors.main500);
    };
};
// const promoCSS = (isPurchaseDailyFreePass: boolean) => (theme: Theme) =>
//   css`
//     display: flex;
//     flex-direction: ${isPurchaseDailyFreePass ? 'column' : 'row'};
//     ${!isPurchaseDailyFreePass &&
//     css`
//       justify-content: space-between;
//       align-items: center;
//     `}
//     width: 100%;
//     height: 100%;
//     padding: 12.5px 10px;
//     .upper-container {
//       display: flex;
//       width: 100%;
//       justify-content: space-between;
//       align-items: center;
//       .timer {
//         display: flex;
//         justify-content: flex-end;
//         align-items: center;
//         padding: 4px 6px;
//         border-radius: 10px;
//         height: 18px;
//         background: ${theme.var.gray900};
//         color: ${theme.var.white};
//         text-align: center;
//         font-size: 10px;
//         font-style: normal;
//         font-weight: 400;
//         line-height: 100%;
//         min-width: 110px;
//       }
//     }
//     .title {
//       color: ${theme.var.white};
//       ${Typography.h6};
//       font-weight: 600;
//     }
//     .under-container {
//       display: flex;
//       // align-items: flex-;
//       color: ${theme.var.white};
//       ${Typography.body11}
//     }
//     .left-container {
//       display: flex;
//       flex-direction: column;
//     }
//     .right-container {
//       display: flex;
//       flex-direction: column;
//       align-items: flex-end;
//       justify-content: space-between;
//       gap: 4px;
//     }
//     .description {
//       color: rgba(255, 255, 255, 0.9);
//       ${!isPurchaseDailyFreePass &&
//       css`
//         background-color: ${theme.var.gray900};
//         padding: 3px 4px;
//         border-radius: ${Radius.xsmall}px;
//         width: fit-content;
//         color: ${theme.var.white};
//       `}
//       margin-top: ${!isPurchaseDailyFreePass ? 4 : 8}px;
//       ${Typography.body11}
//     }
//     .price {
//       color: rgba(248, 248, 248, 0.6);
//       font-size: 10px;
//       text-decoration: line-through;
//     }
//     .discount-price {
//       color: ${theme.var.white};
//       font-size: 18px;
//       font-weight: 600;
//     }
//   `;
var RecommendationSectionList = function() {
    var ref;
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var ref1 = (0,es.useQuery)(constants/* QUERY_KEYS.SECTION */.U7.SECTION("STR"), function() {
        return (0,section/* fetchCurationByType */.Jt)("STR");
    }, {
        staleTime: 1000 * 60 * 15,
        cacheTime: 1000 * 60 * 15,
        suspense: false
    }), recommendation = ref1.data;
    var ref2 = _slicedToArray((0,useModal/* useModal */.d)("popup-modal", {
        routeChange: false
    }), 2), isPopupModalOpen = ref2[0], ref3 = ref2[1], openPopupModal = ref3.open, closePopupModal = ref3.close;
    var hasAd = (recommendation === null || recommendation === void 0 ? void 0 : (ref = recommendation.sections) === null || ref === void 0 ? void 0 : ref.some(function(section) {
        return section.hasAd;
    })) || false;
    var ref4 = (0,es.useQuery)(constants/* QUERY_KEYS.AD.STORY */.U7.AD.STORY(), api_story/* fetchStoryAd */.nM, {
        enabled: !!hasAd,
        suspense: false,
        staleTime: (0,minutesToMilliseconds/* default */.Z)(5)
    }), storyAd = ref4.data;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(home_HomeBanner, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(home_WebtoonStoryList, {}),
            function() {
                var ref;
                var visibleCount = 0;
                return recommendation === null || recommendation === void 0 ? void 0 : (ref = recommendation.sections) === null || ref === void 0 ? void 0 : ref.map(function(section, index) {
                    if (section.viewType === constants/* CurationViewType.userRanking */.SM.userRanking) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Fragment, {}, "empty-".concat(index));
                    }
                    if (section.viewType === constants/* CurationViewType.honorUser */.SM.honorUser) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Fragment, {}, "empty-".concat(index));
                    }
                    visibleCount++;
                    var showNativeAd = visibleCount >= 2 && (visibleCount - 2) % 3 === 0;
                    var handleClickCuration = function() {
                        var ref;
                        firebase.logEvent("home_curation_click", {
                            title: (ref = section === null || section === void 0 ? void 0 : section.name) !== null && ref !== void 0 ? ref : ""
                        });
                    };
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        css: pages_containerCSS,
                        onClick: handleClickCuration,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RecommendationStorySection, {
                            section: section,
                            ad: storyAd,
                            openPopupModal: openPopupModal,
                            showNativeAd: showNativeAd,
                            showFreeChatCta: false
                        })
                    }, section.id + index.toString());
                });
            }(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(modal_PopupModal, {
                open: isPopupModalOpen,
                onClose: closePopupModal,
                name: "popup-modal"
            })
        ]
    });
};
var HomeDetail = function() {
    var ref = (0,global/* useGlobalContext */.bN)(), platform = ref.platform, isCheming = ref.isCheming;
    var router = (0,next_router.useRouter)();
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var queryClient = (0,es.useQueryClient)();
    var myBundlePassQueryKey = constants/* QUERY_KEYS.PAYMENT.MY_BUNDLE_LIST */.U7.PAYMENT.MY_BUNDLE_LIST();
    (0,useBroadcastChannel/* useBroadcastChannel */.t)(useBroadcastChannel/* BROADCAST_CHANNEL.PURCHASE_DAILY_FREE_PASS */._.PURCHASE_DAILY_FREE_PASS, function() {
        queryClient.refetchQueries(myBundlePassQueryKey);
    });
    var ref2 = (0,es.useQuery)(constants/* QUERY_KEYS.HOME_SECTION_LIST */.U7.HOME_SECTION_LIST, function() {
        return (0,section/* fetchSections */.Gr)(constants/* SectionType.standard */.bA.standard);
    }, {
        staleTime: 1000 * 60 * 15,
        cacheTime: 1000 * 60 * 15,
        suspense: false
    }), sectionList = ref2.data;
    var isMounted = (0,useMounted/* useMounted */.s)();
    var initialTab = [
        {
            label: "추천",
            value: 9998
        },
        {
            label: "최신"
        },
        {
            label: "베스트"
        },
        {
            label: "테스트"
        },
        {
            label: "친구의연애"
        }, 
    ];
    var recommendTab = [
        {
            label: "추천",
            value: 9998
        }, 
    ];
    var parsedTab = sectionList ? recommendTab.concat(sectionList === null || sectionList === void 0 ? void 0 : sectionList.map(function(section) {
        return {
            label: section.name,
            value: section.id
        };
    })) : _toConsumableArray(initialTab);
    var handleClickTab = function(tab) {
        var ref;
        var label = (ref = parsedTab === null || parsedTab === void 0 ? void 0 : parsedTab.find(function(t) {
            return t.value === tab;
        })) === null || ref === void 0 ? void 0 : ref.label;
        firebase.logEvent("home_tab_click", {
            tab: label
        });
    };
    var tabs = (0,Tab/* useTab */.x)(parsedTab, {
        replace: false,
        withoutReRendering: false,
        onClickTab: handleClickTab
    });
    var _activeTab = tabs.activeTab, activeTab = _activeTab === void 0 ? 9998 : _activeTab;
    var handleNavigateCreate = function() {
        if (platform === constants/* Platform.web */.t4.web) {
            return router.push("/studio");
        } else {
            (0,misc/* openDeepLink */.Hu)("chatie-app://navigation?activeTab=MYPAGE", router);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(SafeArea/* default */.Z, {
        bottom: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HomeHeaderContainer/* default */.Z, {
                tabs: tabs
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: homeContainerCSS,
                suppressHydrationWarning: true,
                children: [
                    activeTab == 9998 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RecommendationSectionList, {}),
                    activeTab != 9998 && activeTab && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Suspense, {
                        fallback: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ListLoading, {}),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            className: "section-container",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SectionStoryList, {
                                sectionId: activeTab
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: footerCSS,
                onClick: function() {
                    return setOpen(!open);
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                        className: "title",
                        children: [
                            "(주) 아이네블루메 사업자 정보",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                icon: icon/* CheckCircle */.fU,
                                size: esm/* Sizes.xsmall */.u8.xsmall,
                                color: theme.var.gray400
                            })
                        ]
                    }),
                    open && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "multiline",
                        children: "사업자등록번호 : 591-81-00825\n대표이사 : 최재현\n주소 :서울 강남구 테헤란로79길 6, JS타워 516호\nEmail : help@eineblu.me"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        children: "\xa9 EINEBLUME CO., LTD. 2018-2019 All Rights Reserved"
                    })
                ]
            }),
            isMounted && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: floatingButtonContainerCSS(isCheming),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: "floating-wrapper",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: "floating-create",
                        onClick: handleNavigateCreate,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                            icon: icon/* Pencil */.z,
                            color: "white",
                            onClick: handleNavigateCreate
                        })
                    })
                })
            })
        ]
    });
};
var pages_layoutCSS = (0,emotion_react_browser_esm.css)(pages_templateObject4(), (0,css/* safeArea */.BI)("top", "padding", 0));
var bannerSkeletonCSS = (0,emotion_react_browser_esm.css)(pages_templateObject5());
var Home = function() {
    var isProduction = (0,misc/* isEnv */.h5)("production");
    (0,react.useEffect)(function() {
        if ( true && !isProduction) {
            setupPerfReporting();
        }
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Layout/* default */.Z, {
        css: pages_layoutCSS,
        isSSR: true,
        isPush: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HomeDetail, {})
    });
};
/* harmony default export */ var pages = ((0,auth/* withAuth */.QO)(Home, {
    isSignInRequired: false,
    LoadingComponent: HomeLoading
}));


/***/ }),

/***/ 70182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useLoadingStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88766);

var useLoadingStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)(function(set) {
    return {
        isLoading: false,
        setLoading: function(isLoading) {
            set({
                isLoading: isLoading
            });
        }
    };
});


/***/ }),

/***/ 12293:
/***/ (function(module) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),

/***/ 80875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(52259),
    now = __webpack_require__(17758),
    toNumber = __webpack_require__(7425);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 17758:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(71737);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 47304:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSum = __webpack_require__(12293),
    identity = __webpack_require__(37174);

/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
  return (array && array.length)
    ? baseSum(array, identity)
    : 0;
}

module.exports = sum;


/***/ }),

/***/ 74001:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root)
    return "0";
  if (RootIds.has(root))
    return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  let id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  let callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip)
      return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => {
      if (skip || !ref)
        return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current)
            callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1425,496,5277,741,2127,4448,1385,6683,8368,6538,6117,9721,952,5589,6861,8371,1870,1743,3570,9774,2888,179], function() { return __webpack_exec__(53174); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);